import { ApiBaseFront } from "../../front/api-base-front";

type Params = {
  kijshopCd: string,
  name: string,
  level: number,
  parentId?: string,
  indexes?: string,
};

export class ApiPrintFavoriteFolderPost extends ApiBaseFront<{}> {
  constructor(param: Params) {
    const {
      kijshopCd,
      ..._param
    } = param;

    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/favfolder`,
      'JSON',
      _param,
    );
  }
}
